/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { itemTreeSetResponseSchema } from './itemTreeSetResponseSchema';

export const listDocumentItemTreeSetResponseSchema = z.object({
  get data() {
    return z.array(itemTreeSetResponseSchema);
  },
  recordCount: z.int().nullish(),
});
